import React, { useCallback } from 'react'
import { useTranslation } from "react-i18next";
import { Modal, Button } from 'react-bootstrap';
import styles from './FilePreviewModal.module.css'
import FileViewer from 'react-file-viewer';
import noImage from '../../../assets/no-image.png'

const FilePreviewModal = (props) => {
    const { onHide, show, fileType, fileUrl } = props
    const [t] = useTranslation('common');

    const onError = useCallback((e) => { console.log('Error to load') }, []);

    const getImageElementBySource = useCallback(
        (src) => <img className={styles['image-file']} src={src} alt={t('image')} onError={(event) => { event.target.onerror = null; event.target.src = noImage }} />
        , [])

    let SingleFileContainer;
    switch (fileType) {
        case 'gif':
        case 'jpg':
        case 'jpeg':
        case 'png':
            SingleFileContainer = getImageElementBySource(fileUrl)
            break;
        case 'doc':
        case 'docx':
            SingleFileContainer = <FileViewer fileType={fileType} filePath={fileUrl} onError={onError} />
            break;
        case 'pdf':
            SingleFileContainer = <FileViewer fileType={fileType} filePath={fileUrl} onError={onError} />
            break;
        case 'mp3':
        case 'wav':
        case 'ogg':
        case 'aac':
        case 'm4a':
            SingleFileContainer = <FileViewer fileType={fileType} filePath={fileUrl} onError={onError} />
            break;
        case 'csv':
        case 'xls':
        case 'xlsx':
            SingleFileContainer = <FileViewer fileType={fileType} filePath={fileUrl} onError={onError} />
            break;
        case 'pptx':
        case 'ppt':
            SingleFileContainer = <FileViewer fileType={fileType} filePath={fileUrl} onError={onError} />
            break
        case 'txt':
            SingleFileContainer = <FileViewer fileType={fileType} filePath={fileUrl} onError={onError} />
            break
        case 'mp4':
            SingleFileContainer = <FileViewer fileType={fileType} filePath={fileUrl} onError={onError} />
            break
        default:
            SingleFileContainer = <FileViewer fileType={fileType} filePath={fileUrl} onError={onError} />
    }

    return (
        <Modal centered={true} size='lg' className={`${styles.mainModal}`} show={show} >

            <Modal.Header>
                <Modal.Title>{t('Preview')}</Modal.Title>
            </Modal.Header>
            <Modal.Body className={styles.modalBody}>
                {SingleFileContainer}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>{t('Close')}</Button>
            </Modal.Footer>


        </Modal>
    )
}

export default FilePreviewModal